import { LitElement, PropertyValues, css, html, nothing } from 'lit'
import { property } from 'lit/decorators.js'
import '@spectrum-web-components/bundle/elements.js'
import { translationKeys as ctk } from '../../common/opening-hours.i18n'
import { currentLanguage as lang } from '../../common/i18n'

export class DayOfWeek extends LitElement {

    @property({ type: Boolean }) abbr = false
    @property({ type: String }) name: string | undefined

    protected firstUpdated(_changedProperties: PropertyValues): void {
        console.log('init day of Week')
    }

    _getAbbreviation() {
        if (!this.name || !(this.name in ctk.en)) return ''

        const langDict = ctk[lang as keyof typeof ctk]
        if (!langDict) return ''

      return langDict[`${this.name}Abbr` as keyof typeof langDict] ?? ''
    }

    render() {
        const tr = ctk[lang as keyof typeof ctk] as Record<string, string>

        return html`
      <span>
        ${this.name ?
                html`
                <span>
                ${this.abbr
                        ? html`
                    <abbr> ${this._getAbbreviation()} </abbr>
                    `
                        : html`
                    <span> ${tr[this.name as string]} </span>
                    `
                    }
                </span>
            `
                : nothing}
        </span>
    `
    }

    static styles = css`
    :host {
      display: inline-block
    }
  `
}

if (!customElements.get('day-of-week')) {
    customElements.define('day-of-week', DayOfWeek)
}

declare global {
    interface HTMLElementTagNameMap {
        'day-of-week': DayOfWeek
    }
}
